import { Step, StepLabel, Stepper } from '@mui/material';
import React from 'react';

interface SimpleStepperProps {
  stepLabels: string[];
  activeStep: number;
  callbacks?: Function[];
}

function SimpleStepper({ stepLabels, activeStep, callbacks = [] }: SimpleStepperProps) {
  return (
    <Stepper activeStep={activeStep}>
      {stepLabels.map((label, index) => (
        <Step
          key={label}
          onClick={() => callbacks[index] && callbacks[index]()}
          sx={{
            cursor: callbacks[index] && 'pointer',
          }}
        >
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

export default SimpleStepper;
